import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { LoyaltyUserModel } from "@NA/Widgets/LoyaltyRewards/LoyaltyRewardsModel";
import { getLoyaltyUser } from "@NA/Widgets/LoyaltyRewards/LoyaltyRewardsServices";
import { createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<any, LoyaltyUserModel>;

export const DispatchLoyaltyLoading: HandlerType = props => {
    props.dispatch({
        type: "AccountPage/GetLoyaltyUser",
        result: props.parameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
        props.apiResult = await getLoyaltyUser(props.parameter);
};

export const DispatchCompleteLoadLoyaltyUser: HandlerType = props => {
    props.dispatch({
        type: "Accountpage/DispatchCompleteLoadLoyaltyUser",
        user: props.apiResult,
    });
};

export const chain = [DispatchLoyaltyLoading, RequestDataFromApi, DispatchCompleteLoadLoyaltyUser];

const loadLoyaltyRewardsUser = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        userID: "",
    },
    "loadLoyaltyRewardsUser",
);
export default loadLoyaltyRewardsUser;